module.exports = __webpack_public_path__ + "img/1fb2ebf.png";